import {
    Typography,
    makeStyles,
    CardContent,
    Card,
    Grid,
    CardMedia,
    CardActions,
    ListItem,
    ListItemIcon,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { db } from "../../../../../firebase";
import logo from '../../../../../assets/logo.png'
import ForRentCostumesListLoading from "./for-rent-costumes-list-loading";
import ForRentCostumesListEmpty from "./for-rent-costumes-list-empty";
import { getForRentCostumesService } from "./for-rent-costumes-list-service";
import { Link } from "react-router-dom";
import { showErrorSnackbar } from "../../../../shared/snackbar/snackbar-slice";
import {
    FiberManualRecord,
} from "@material-ui/icons";
import { green, orange, red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right"
    },
    text: {
      color: "#111111",
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    }
}));

const ForRentCostumesList = () => {
    const classes = useStyles();
    const forRentCostumesCollection = useSelector((state) => state.forRentCostumesListSlice.rows);
    const isLoading = useSelector((state) => state.forRentCostumesListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getForRentCostumesService(dispatch, db, "items");
            } catch(e) {
                dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                console.error("ForRentCostumesList getForRentCostumesService error: ", e);
            }
        };
        fetchData();
    }, [dispatch]);

    // return loading state if isLoading is true
    if (isLoading) {
        return <ForRentCostumesListLoading/>
    }

    // return empty state if isLoading is false and forRentCostumesCollection has no collection
    if (!isLoading && forRentCostumesCollection.length === 0) {
        return <ForRentCostumesListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">For Rent Costumes</Typography>
            <Grid container spacing={1}>
                {forRentCostumesCollection.map((row) => {
                    let iconColor = green[500]; // Default color

                    if (row.status === 'Reserved') {
                        iconColor = orange[500]; // Change color for 'Reserved' status
                    } else if (row.status === 'Rented') {
                        iconColor = red[500]; // Change color for 'Rented' status
                    }

                    return (
                        <Grid item xs={6} sm={4} md={3} lg={2} key={row.id}>
                            <Link
                                // to={`/app/for-rent/costumes/details/${row.id}`}
                                style={{ textDecoration: 'none' }}
                            >
                                <Card variant="outlined">
                                    <CardMedia
                                        component="img"
                                        height="194"
                                        image={row.item_thumbnail ? row.item_thumbnail : logo}
                                        alt="PeriCoCo"
                                    />
                                    <CardContent>
                                        <Typography variant="h5" component="div" className={classes.text} align="left">
                                            {row.name}
                                        </Typography>
                                        <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                            {`Rent: PHP ${row.rent_price}`}
                                        </Typography>
                                        <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                            {`Deposit: PHP ${row.deposit}`}
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <ListItem>
                                            <ListItemIcon style={{ color: iconColor }}>
                                                <FiberManualRecord/>
                                            </ListItemIcon>
                                            <Typography sx={{ mb: 1.5 }} variant="overline" className={classes.text}>
                                                {row.status}
                                            </Typography>
                                        </ListItem>
                                    </CardActions>
                                </Card>
                            </Link>
                        </Grid>
                    )
                })}
            </Grid>
        </>
        
    )
};

export default ForRentCostumesList;